export default class Loader{
    constructor(private isPreLoading = false) {
    }

    private loadingCount = 0;
    
    public get loading() {
        return this.isPreLoading || this.loadingCount > 0;
    }
    
    public startLoading()
    {
        this.isPreLoading = false;
        this.loadingCount++;
    }

    public endLoading()
    {
        this.isPreLoading = false;
        this.loadingCount--;
    }
}